var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlockchain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "3.23,21 13.48,16.02 23.73,21 13.48,25.98 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(252,234,107)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "13.48,25.98 13.48,38.21 23.73,33.22 23.73,21 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(252,234,107)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3.23,33.22 3.23,21 13.48,25.98 13.48,38.21 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(213,195,67)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "34.75,71.8 45,66.81 55.25,71.8 45,76.78 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(252,234,107)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45,76.78 45,89 55.25,84.02 55.25,71.8 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(252,234,107)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "34.75,84.02 34.75,71.8 45,76.78 45,89 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(213,195,67)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "34.75,38.89 45,33.91 55.25,38.89 45,43.87 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(252,234,107)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45,43.87 45,56.09 55.25,51.11 55.25,38.89 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(252,234,107)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "34.75,51.11 34.75,38.89 45,43.87 45,56.09 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(213,195,67)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "34.75,5.98 45,1 55.25,5.98 45,10.96 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(93,213,216)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45,10.96 45,23.19 55.25,18.2 55.25,5.98 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(93,213,216)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "34.75,18.2 34.75,5.98 45,10.96 45,23.19 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(66,166,169)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3.23,56.78 13.48,51.79 23.73,56.78 13.48,61.76 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(93,213,216)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "13.48,61.76 13.48,73.98 23.73,69 23.73,56.78 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(93,213,216)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3.23,69 3.23,56.78 13.48,61.76 13.48,73.98 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(66,166,169)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.27,56.78 76.52,51.79 86.77,56.78 76.52,61.76 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(93,213,216)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.52,61.76 76.52,73.98 86.77,69 86.77,56.78 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(93,213,216)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.27,69 66.27,56.78 76.52,61.76 76.52,73.98 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(66,166,169)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.27,21 76.52,16.02 86.77,21 76.52,25.98 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(93,213,216)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.52,25.98 76.52,38.21 86.77,33.22 86.77,21 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(93,213,216)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.27,33.22 66.27,21 76.52,25.98 76.52,38.21 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(66,166,169)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 13.479 26.983 c -0.149 0 -0.299 -0.034 -0.437 -0.101 L 2.791 21.9 c -0.344 -0.167 -0.563 -0.517 -0.563 -0.899 s 0.219 -0.732 0.563 -0.899 l 10.251 -4.981 c 0.275 -0.134 0.599 -0.134 0.874 0 l 10.251 4.981 c 0.344 0.167 0.563 0.517 0.563 0.899 s -0.219 0.732 -0.563 0.899 l -10.251 4.982 C 13.778 26.949 13.628 26.983 13.479 26.983 z M 5.516 21.001 l 7.963 3.87 l 7.963 -3.87 l -7.963 -3.87 L 5.516 21.001 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 13.479 39.206 c -0.149 0 -0.299 -0.034 -0.437 -0.101 L 2.791 34.124 c -0.344 -0.167 -0.563 -0.517 -0.563 -0.899 V 21.001 c 0 -0.345 0.177 -0.665 0.47 -0.848 c 0.292 -0.183 0.658 -0.202 0.967 -0.052 l 9.814 4.77 l 9.814 -4.77 c 0.309 -0.151 0.675 -0.131 0.967 0.052 c 0.292 0.183 0.47 0.503 0.47 0.848 v 12.224 c 0 0.383 -0.219 0.732 -0.563 0.899 l -10.251 4.981 C 13.778 39.172 13.628 39.206 13.479 39.206 z M 4.228 32.599 l 9.251 4.496 l 9.251 -4.496 v -10 l -8.814 4.284 c -0.275 0.134 -0.599 0.134 -0.874 0 l -8.814 -4.284 V 32.599 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 13.479 39.206 c -0.552 0 -1 -0.448 -1 -1 V 25.983 c 0 -0.552 0.448 -1 1 -1 s 1 0.448 1 1 v 12.223 C 14.479 38.758 14.031 39.206 13.479 39.206 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 11.963 c -0.149 0 -0.299 -0.034 -0.437 -0.101 L 34.312 6.881 c -0.344 -0.167 -0.563 -0.517 -0.563 -0.899 s 0.219 -0.732 0.563 -0.899 l 10.251 -4.982 c 0.275 -0.134 0.599 -0.134 0.874 0 l 10.251 4.982 c 0.344 0.167 0.563 0.517 0.563 0.899 s -0.219 0.732 -0.563 0.899 l -10.251 4.981 C 45.299 11.93 45.149 11.963 45 11.963 z M 37.037 5.982 L 45 9.852 l 7.963 -3.87 L 45 2.112 L 37.037 5.982 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 24.187 c -0.149 0 -0.299 -0.034 -0.437 -0.101 l -10.251 -4.981 c -0.344 -0.167 -0.563 -0.517 -0.563 -0.899 V 5.982 c 0 -0.345 0.177 -0.665 0.469 -0.848 c 0.293 -0.184 0.659 -0.202 0.968 -0.052 L 45 9.852 l 9.813 -4.769 c 0.311 -0.15 0.677 -0.131 0.968 0.052 c 0.292 0.183 0.47 0.503 0.47 0.848 v 12.223 c 0 0.383 -0.219 0.732 -0.563 0.899 l -10.251 4.981 C 45.299 24.153 45.149 24.187 45 24.187 z M 35.749 17.579 L 45 22.075 l 9.251 -4.496 v -10 l -8.814 4.283 c -0.275 0.134 -0.599 0.134 -0.874 0 L 35.749 7.58 V 17.579 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 24.187 c -0.552 0 -1 -0.448 -1 -1 V 10.963 c 0 -0.552 0.448 -1 1 -1 s 1 0.448 1 1 v 12.223 C 46 23.739 45.552 24.187 45 24.187 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 77.776 c -0.149 0 -0.299 -0.033 -0.437 -0.101 l -10.251 -4.981 c -0.344 -0.167 -0.563 -0.517 -0.563 -0.899 s 0.219 -0.732 0.563 -0.899 l 10.251 -4.981 c 0.275 -0.135 0.599 -0.135 0.874 0 l 10.251 4.981 c 0.344 0.167 0.563 0.517 0.563 0.899 s -0.219 0.732 -0.563 0.899 l -10.251 4.981 C 45.299 77.743 45.149 77.776 45 77.776 z M 37.037 71.795 L 45 75.664 l 7.963 -3.869 L 45 67.926 L 37.037 71.795 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 90 c -0.149 0 -0.299 -0.033 -0.437 -0.101 l -10.251 -4.981 c -0.344 -0.167 -0.563 -0.517 -0.563 -0.899 V 71.795 c 0 -0.345 0.177 -0.665 0.469 -0.848 c 0.293 -0.183 0.659 -0.202 0.968 -0.052 L 45 75.664 l 9.813 -4.769 c 0.311 -0.149 0.677 -0.132 0.968 0.052 c 0.292 0.183 0.47 0.503 0.47 0.848 v 12.224 c 0 0.383 -0.219 0.732 -0.563 0.899 l -10.251 4.981 C 45.299 89.967 45.149 90 45 90 z M 35.749 83.393 L 45 87.888 l 9.251 -4.495 v -10 l -8.814 4.283 c -0.275 0.135 -0.599 0.135 -0.874 0 l -8.814 -4.283 V 83.393 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 90 c -0.552 0 -1 -0.447 -1 -1 V 76.776 c 0 -0.553 0.448 -1 1 -1 s 1 0.447 1 1 V 89 C 46 89.553 45.552 90 45 90 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 13.479 62.758 c -0.149 0 -0.299 -0.033 -0.437 -0.101 L 2.791 57.675 c -0.344 -0.167 -0.563 -0.517 -0.563 -0.899 s 0.219 -0.732 0.563 -0.899 l 10.251 -4.981 c 0.275 -0.135 0.599 -0.135 0.874 0 l 10.251 4.981 c 0.344 0.167 0.563 0.517 0.563 0.899 s -0.219 0.732 -0.563 0.899 l -10.251 4.982 C 13.778 62.725 13.628 62.758 13.479 62.758 z M 5.516 56.775 l 7.963 3.87 l 7.963 -3.87 l -7.963 -3.869 L 5.516 56.775 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 13.479 74.98 c -0.149 0 -0.299 -0.033 -0.437 -0.101 L 2.791 69.898 c -0.344 -0.167 -0.563 -0.517 -0.563 -0.899 V 56.775 c 0 -0.345 0.177 -0.665 0.47 -0.848 c 0.292 -0.184 0.658 -0.203 0.967 -0.052 l 9.814 4.77 l 9.814 -4.77 c 0.309 -0.151 0.675 -0.132 0.967 0.052 c 0.292 0.183 0.47 0.503 0.47 0.848 v 12.224 c 0 0.383 -0.219 0.732 -0.563 0.899 L 13.916 74.88 C 13.778 74.947 13.628 74.98 13.479 74.98 z M 4.228 68.373 l 9.251 4.495 l 9.251 -4.495 v -10 l -8.814 4.284 c -0.275 0.135 -0.599 0.135 -0.874 0 l -8.814 -4.284 V 68.373 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 13.479 74.98 c -0.552 0 -1 -0.447 -1 -1 V 61.758 c 0 -0.553 0.448 -1 1 -1 s 1 0.447 1 1 V 73.98 C 14.479 74.533 14.031 74.98 13.479 74.98 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 76.521 62.758 c -0.149 0 -0.299 -0.033 -0.438 -0.101 l -10.251 -4.982 c -0.344 -0.167 -0.563 -0.517 -0.563 -0.899 s 0.219 -0.732 0.563 -0.899 l 10.251 -4.981 c 0.277 -0.135 0.598 -0.135 0.875 0 l 10.25 4.981 c 0.344 0.167 0.563 0.517 0.563 0.899 s -0.219 0.732 -0.563 0.899 l -10.25 4.982 C 76.82 62.725 76.671 62.758 76.521 62.758 z M 68.559 56.775 l 7.963 3.87 l 7.963 -3.87 l -7.963 -3.869 L 68.559 56.775 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 76.521 74.98 c -0.149 0 -0.299 -0.033 -0.438 -0.101 l -10.251 -4.981 c -0.344 -0.167 -0.563 -0.517 -0.563 -0.899 V 56.775 c 0 -0.345 0.178 -0.665 0.47 -0.848 c 0.292 -0.184 0.658 -0.203 0.968 -0.052 l 9.813 4.77 l 9.813 -4.77 c 0.311 -0.15 0.677 -0.131 0.968 0.052 c 0.292 0.183 0.47 0.503 0.47 0.848 v 12.224 c 0 0.383 -0.219 0.732 -0.563 0.899 l -10.25 4.981 C 76.82 74.947 76.671 74.98 76.521 74.98 z M 67.271 68.373 l 9.251 4.495 l 9.25 -4.495 v -10 l -8.813 4.284 c -0.277 0.135 -0.598 0.135 -0.875 0 l -8.813 -4.284 V 68.373 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 76.521 74.98 c -0.553 0 -1 -0.447 -1 -1 V 61.758 c 0 -0.553 0.447 -1 1 -1 s 1 0.447 1 1 V 73.98 C 77.521 74.533 77.074 74.98 76.521 74.98 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 76.521 26.983 c -0.149 0 -0.299 -0.034 -0.438 -0.101 L 65.833 21.9 c -0.344 -0.167 -0.563 -0.517 -0.563 -0.899 s 0.219 -0.732 0.563 -0.899 l 10.251 -4.981 c 0.277 -0.134 0.598 -0.134 0.875 0 l 10.25 4.981 c 0.344 0.167 0.563 0.517 0.563 0.899 s -0.219 0.732 -0.563 0.899 l -10.25 4.982 C 76.82 26.949 76.671 26.983 76.521 26.983 z M 68.559 21.001 l 7.963 3.87 l 7.962 -3.87 l -7.962 -3.87 L 68.559 21.001 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 76.521 39.206 c -0.149 0 -0.299 -0.034 -0.438 -0.101 l -10.251 -4.981 c -0.344 -0.167 -0.563 -0.517 -0.563 -0.899 V 21.001 c 0 -0.345 0.178 -0.665 0.47 -0.848 c 0.292 -0.183 0.658 -0.202 0.968 -0.052 l 9.813 4.77 l 9.813 -4.77 c 0.311 -0.149 0.677 -0.13 0.968 0.052 c 0.292 0.183 0.47 0.503 0.47 0.848 v 12.224 c 0 0.383 -0.219 0.732 -0.563 0.899 l -10.25 4.981 C 76.82 39.172 76.671 39.206 76.521 39.206 z M 67.271 32.599 l 9.251 4.496 l 9.25 -4.496 v -10 l -8.813 4.283 c -0.277 0.134 -0.598 0.134 -0.875 0 l -8.813 -4.284 V 32.599 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 76.521 39.206 c -0.553 0 -1 -0.448 -1 -1 V 25.983 c 0 -0.552 0.447 -1 1 -1 s 1 0.448 1 1 v 12.223 C 77.521 38.758 77.074 39.206 76.521 39.206 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 34.748 74.278 c -0.159 0 -0.321 -0.038 -0.471 -0.118 l -11.019 -5.902 c -0.487 -0.261 -0.67 -0.867 -0.409 -1.354 c 0.26 -0.486 0.867 -0.669 1.354 -0.409 l 11.019 5.902 c 0.487 0.261 0.67 0.867 0.409 1.354 C 35.45 74.087 35.105 74.278 34.748 74.278 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 13.479 52.794 c -0.552 0 -1 -0.447 -1 -1 V 38.206 c 0 -0.552 0.448 -1 1 -1 s 1 0.448 1 1 v 13.588 C 14.479 52.347 14.031 52.794 13.479 52.794 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 23.731 23.624 c -0.357 0 -0.702 -0.191 -0.882 -0.528 c -0.261 -0.487 -0.078 -1.093 0.409 -1.354 l 11.019 -5.903 c 0.487 -0.26 1.093 -0.077 1.354 0.409 c 0.261 0.487 0.078 1.093 -0.409 1.354 l -11.019 5.903 C 24.052 23.586 23.89 23.624 23.731 23.624 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 66.27 23.624 c -0.159 0 -0.321 -0.038 -0.472 -0.119 l -11.02 -5.903 c -0.486 -0.261 -0.67 -0.867 -0.409 -1.354 c 0.261 -0.486 0.868 -0.671 1.354 -0.409 l 11.02 5.903 c 0.486 0.261 0.67 0.867 0.409 1.354 C 66.972 23.433 66.626 23.624 66.27 23.624 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 76.521 52.794 c -0.553 0 -1 -0.447 -1 -1 V 38.206 c 0 -0.552 0.447 -1 1 -1 s 1 0.448 1 1 v 13.588 C 77.521 52.347 77.074 52.794 76.521 52.794 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 55.252 74.278 c -0.357 0 -0.702 -0.191 -0.883 -0.528 c -0.261 -0.486 -0.077 -1.093 0.41 -1.354 l 11.02 -5.902 c 0.485 -0.26 1.093 -0.076 1.354 0.41 s 0.077 1.093 -0.41 1.354 l -11.02 5.902 C 55.573 74.24 55.411 74.278 55.252 74.278 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 44.87 c -0.149 0 -0.299 -0.034 -0.437 -0.101 l -10.251 -4.982 c -0.344 -0.167 -0.563 -0.517 -0.563 -0.899 s 0.219 -0.732 0.563 -0.899 l 10.251 -4.981 c 0.275 -0.134 0.599 -0.134 0.874 0 l 10.251 4.981 c 0.344 0.167 0.563 0.517 0.563 0.899 s -0.219 0.732 -0.563 0.899 L 45.437 44.77 C 45.299 44.836 45.149 44.87 45 44.87 z M 37.037 38.888 L 45 42.758 l 7.963 -3.87 L 45 35.019 L 37.037 38.888 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 57.094 c -0.149 0 -0.299 -0.033 -0.437 -0.101 l -10.251 -4.982 c -0.344 -0.167 -0.563 -0.517 -0.563 -0.899 V 38.888 c 0 -0.345 0.177 -0.665 0.47 -0.848 s 0.658 -0.203 0.967 -0.052 L 45 42.758 l 9.813 -4.77 c 0.311 -0.15 0.677 -0.131 0.968 0.052 c 0.292 0.183 0.47 0.503 0.47 0.848 v 12.223 c 0 0.383 -0.219 0.732 -0.563 0.899 l -10.251 4.982 C 45.299 57.061 45.149 57.094 45 57.094 z M 35.749 50.485 L 45 54.981 l 9.251 -4.496 v -10 l -8.814 4.284 c -0.275 0.134 -0.599 0.134 -0.874 0 l -8.814 -4.284 V 50.485 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 57.094 c -0.552 0 -1 -0.447 -1 -1 V 43.87 c 0 -0.552 0.448 -1 1 -1 s 1 0.448 1 1 v 12.224 C 46 56.646 45.552 57.094 45 57.094 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 23.782 57.775 c -0.362 0 -0.712 -0.197 -0.89 -0.541 c -0.253 -0.491 -0.061 -1.094 0.43 -1.348 l 10.968 -5.664 c 0.491 -0.253 1.094 -0.061 1.348 0.43 c 0.253 0.491 0.061 1.094 -0.43 1.348 L 24.24 57.664 C 24.093 57.739 23.936 57.775 23.782 57.775 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 66.228 57.992 c -0.159 0 -0.321 -0.038 -0.472 -0.118 l -10.978 -5.881 c -0.486 -0.261 -0.67 -0.867 -0.409 -1.354 c 0.261 -0.486 0.868 -0.669 1.354 -0.409 l 10.978 5.881 c 0.486 0.261 0.67 0.867 0.409 1.354 C 66.93 57.801 66.584 57.992 66.228 57.992 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 55.252 39.888 c -0.357 0 -0.702 -0.191 -0.883 -0.528 c -0.261 -0.487 -0.077 -1.093 0.41 -1.354 l 11.02 -5.902 c 0.485 -0.262 1.093 -0.078 1.354 0.409 s 0.077 1.093 -0.41 1.354 l -11.02 5.902 C 55.573 39.85 55.411 39.888 55.252 39.888 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 34.748 39.888 c -0.154 0 -0.31 -0.036 -0.456 -0.111 l -11.019 -5.664 c -0.491 -0.252 -0.685 -0.855 -0.432 -1.346 s 0.856 -0.684 1.346 -0.432 l 11.019 5.664 c 0.491 0.252 0.685 0.855 0.432 1.346 C 35.461 39.69 35.111 39.888 34.748 39.888 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockchain);
export default __webpack_public_path__ + "static/media/blockchain.625d6d49a1ec70fb08c465b5bfd06084.svg";
export { ForwardRef as ReactComponent };